export const createHeadline = ({ headlineTitle }) => headlineTitle || 'Fitted Bathrooms';
